// Per-type presentation + click behavior for in-app notifications.
//
// Each notification carries a `type` and a `data` payload. The bell renders the
// matched entry's icon/color and runs its `action` on click. Add new event
// types here (a redirect, a different download, etc.) without touching the bell.
//
// action.kind: 'download-combined' | 'download-export' | 'navigate' | 'none'
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined'
import FileExcelOutlined from '@ant-design/icons/FileExcelOutlined'
import CloseCircleOutlined from '@ant-design/icons/CloseCircleOutlined'
import BellOutlined from '@ant-design/icons/BellOutlined'

const REGISTRY = {
  careTasksMissed: (item) => ({
    Icon: BellOutlined,
    color: 'error',
    action: { kind: 'navigate', to: item.link || '/care/schedule' }
  }),
  // Combined invoice/statement export finished (or failed).
  invoiceBatchExport: (item) => {
    const failed = item.data?.status === 'failed'
    return {
      Icon: failed ? CloseCircleOutlined : FilePdfOutlined,
      color: failed ? 'error' : 'success',
      action: failed
        ? { kind: 'navigate', to: item.link || '/billing/invoices' }
        : { kind: 'download-combined', id: item.data?.batchExportId }
    }
  },
  // Async Rent Roll xlsx export finished (or failed).
  rentRollExport: (item) => {
    const failed = item.data?.status === 'error'
    return {
      Icon: failed ? CloseCircleOutlined : FileExcelOutlined,
      color: failed ? 'error' : 'success',
      action: failed
        ? { kind: 'navigate', to: item.link || '/billing/rent-roll' }
        : {
            kind: 'download-export',
            path: `/rent-rolls/export/${item.data?.exportLogId}/download`,
            fallbackTo: item.link || '/billing/rent-roll'
          }
    }
  },
  // Async AR Aging xlsx export finished (or failed).
  arAgingExport: (item) => {
    const failed = item.data?.status === 'error'
    return {
      Icon: failed ? CloseCircleOutlined : FileExcelOutlined,
      color: failed ? 'error' : 'success',
      action: failed
        ? { kind: 'navigate', to: item.link || '/reports/ar-aging' }
        : {
            kind: 'download-export',
            path: `/ar-aging/export/${item.data?.exportLogId}/download`,
            fallbackTo: item.link || '/reports/ar-aging'
          }
    }
  }
}

const fallback = (item) => ({
  Icon: BellOutlined,
  color: 'primary',
  action: item.link ? { kind: 'navigate', to: item.link } : { kind: 'none' }
})

export const notificationView = (item) => (REGISTRY[item.type] || fallback)(item)

// Snackbar navLink for the new-arrival toast, derived from the same per-type action as the bell.
export const toastNavLink = (item) => {
  const { action } = notificationView(item)
  if (action.kind === 'download-combined' && action.id) {
    return { label: 'Download', downloadPath: `/invoices/combined/${action.id}/download` }
  }
  if (action.kind === 'download-export' && action.path) {
    return { label: 'Download', downloadPath: action.path }
  }
  if (action.kind === 'navigate' && action.to) {
    return { label: 'Open', route: action.to }
  }
  return undefined
}
